import { render, staticRenderFns } from "./BackgroundOverlay.vue?vue&type=template&id=6e672d9d"
import script from "./BackgroundOverlay.vue?vue&type=script&lang=ts"
export * from "./BackgroundOverlay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports